// @flow

import styled, { css } from 'styled-components';

export const Padding = styled.div`
  ${props => props.all != null && css`
    padding: calc(0.5em * ${props.all});
  `}

  ${props => props.x != null && css`
    padding-left: calc(0.5em * ${props.x});
    padding-right: calc(0.5em * ${props.x});
  `}
`;
